/**
 * Drops cloaked EGMs from a list of rows keyed by `slot_number`.
 *
 * Kept free of imports so both the drawer list and the map's pin sets can use it
 * without pulling the casino service (and Amplify) in behind it.
 *
 * `slot_number` is a string at runtime about as often as a number, so both sides
 * are normalised — comparing them raw lets a cloaked EGM slip back onto the map.
 */
export const rejectCloaked = <T extends { slot_number: number | string }>(
  rows: T[],
  cloaked: Set<string>
): T[] => (cloaked.size === 0 ? rows : rows.filter((row) => !cloaked.has(String(row.slot_number))));
